import type { FunctionComponent, ReactNode } from 'react';

export interface LimitProps {
  min: ReactNode;
  max: ReactNode;
}

export const Limit: FunctionComponent<LimitProps> = ({ min, max }) => {
  return (
    <>
      {min}
      {' - '}
      {max}
    </>
  );
};
